import React, { useContext, useState, useMemo, useCallback, useRef, useEffect } from 'react';
import { Link } from 'components';
import { Hamburger, AccountUI, MobileNav, Cart, Nav } from './components';
import Headroom from 'react-headroom';
import classnames from 'classnames';
import useBreakpoint from 'hooks/useBreakpoint';
import { HeaderContext } from 'constants/context';
import styled from 'styled-components';
import settings from 'settings';
import { CloseIcon } from 'components/styled';
import { useLocation } from 'react-router-dom';
import { useStore } from 'store';
import { displayNumber } from 'utils/helpers';

const edcatLogo = (
  <svg width="112px" height="32px" viewBox="0 0 112 32">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g>
          <path d="M8.328,20.408 L11.376,20.408 C10.752,22.784 8.64,24.32 5.928,24.32 C2.376,24.32 0,21.896 0,18.272 C0,14.72 2.472,12.104 5.832,12.104 C9.288,12.104 11.568,14.672 11.568,18.56 L11.568,19.04 L3.24,19.04 C3.312,20.984 4.248,22.04 5.952,22.04 C7.128,22.04 7.848,21.56 8.328,20.408 Z M3.24,17 L8.328,17 C8.136,15.32 7.248,14.384 5.832,14.384 C4.416,14.384 3.408,15.392 3.24,17 Z M25.017,8 L25.017,24.008 L21.993,24.008 L21.993,22.52 C21.201,23.744 20.073,24.32 18.489,24.32 C15.297,24.32 13.233,21.896 13.233,18.152 C13.233,14.48 15.249,12.08 18.321,12.08 C19.857,12.08 21.105,12.704 21.849,13.832 L21.849,8 L25.017,8 Z M19.209,14.552 C17.457,14.552 16.425,15.848 16.425,18.128 C16.425,20.36 17.481,21.728 19.185,21.728 C20.937,21.728 21.969,20.408 21.969,18.152 C21.969,15.92 20.913,14.552 19.209,14.552 Z M35.754,19.568 C35.514,21.104 34.65,21.92 33.282,21.92 C31.578,21.92 30.57,20.576 30.57,18.248 C30.57,15.872 31.602,14.504 33.354,14.504 C34.578,14.504 35.418,15.224 35.658,16.472 L38.778,16.472 C38.514,13.784 36.426,12.104 33.33,12.104 C29.73,12.104 27.378,14.552 27.378,18.32 C27.378,21.944 29.73,24.32 33.282,24.32 C36.378,24.32 38.442,22.544 38.85,19.568 L35.754,19.568 Z M51.555,24.008 L48.315,24.008 C48.147,23.48 48.123,23.288 48.123,22.88 C47.115,23.84 45.867,24.32 44.283,24.32 C41.763,24.32 40.227,23 40.227,20.816 C40.227,19.4 40.923,18.344 42.267,17.792 C42.891,17.504 43.563,17.384 45.291,17.144 C47.787,16.832 48.099,16.688 48.099,15.752 C48.099,14.744 47.427,14.24 46.011,14.24 C44.547,14.24 43.947,14.696 43.731,15.968 L40.731,15.968 C40.923,13.424 42.747,12.104 46.083,12.104 C47.883,12.104 49.299,12.488 50.187,13.208 C50.979,13.856 51.195,14.456 51.195,16.136 C51.195,16.424 51.195,16.448 51.171,17.792 C51.171,18.248 51.171,18.992 51.147,20.024 L51.147,20.888 C51.147,22.544 51.243,23.24 51.555,24.008 Z M48.075,19.664 L48.075,18.344 C47.571,18.656 47.139,18.776 45.843,18.944 C44.067,19.208 43.491,19.64 43.491,20.696 C43.491,21.656 44.163,22.256 45.267,22.256 C46.179,22.256 46.971,21.92 47.547,21.296 C47.955,20.84 48.075,20.456 48.075,19.664 Z M59.02,11.5 L56.668,11.5 L56.668,8 L53.5,8 L53.5,12.504 L53.5,14.64 L53.5,19.992 C53.5,22.032 53.596,22.56 54.004,23.16 C54.532,23.952 55.444,24.264 57.076,24.264 C57.724,24.264 58.228,24.24 59.02,24.144 L59.02,21.72 C58.636,21.768 58.348,21.792 58.06,21.792 C56.86,21.792 56.668,21.552 56.668,20.112 L56.648,14 L59,14 L59.02,11.5 Z" id="edcat" fill="#131413"></path>
          <path d="M67.192,7.992 L67.192,14.616 C67.888,13.008 69.376,12.12 71.32,12.12 C74.464,12.12 76.48,14.496 76.48,18.192 C76.48,21.96 74.44,24.336 71.272,24.336 C69.208,24.336 67.84,23.496 67.096,21.744 L67.096,24 L65.776,24 L65.776,7.992 L67.192,7.992 Z M71.176,13.296 C68.68,13.296 67.144,15.168 67.144,18.216 C67.144,21.216 68.704,23.16 71.128,23.16 C73.504,23.16 75.064,21.216 75.064,18.216 C75.064,15.24 73.528,13.296 71.176,13.296 Z M87.529,20.184 L88.873,20.184 C88.369,22.848 86.593,24.336 83.953,24.336 C80.761,24.336 78.649,21.96 78.649,18.36 C78.649,14.712 80.833,12.12 83.929,12.12 C85.897,12.12 87.529,13.176 88.393,15.024 C88.825,15.96 89.017,17.016 89.017,18.576 L80.065,18.576 C80.137,21.504 81.553,23.16 83.977,23.16 C85.825,23.16 87.049,22.128 87.529,20.184 Z M80.089,17.4 L87.577,17.4 C87.457,14.88 86.041,13.296 83.881,13.296 C81.745,13.296 80.401,14.736 80.089,17.4 Z M95.722,12.456 L93.322,12.456 L93.322,8.904 L91.906,8.904 L91.906,12.456 L89.89,12.456 L89.89,13.632 L91.906,13.632 L91.906,20.208 C91.906,22.272 91.954,22.704 92.194,23.136 C92.554,23.784 93.25,24.072 94.45,24.072 C94.906,24.072 95.218,24.048 95.722,24 L95.722,22.776 C95.314,22.824 95.05,22.848 94.786,22.848 C93.562,22.848 93.322,22.536 93.322,20.928 L93.322,13.632 L95.722,13.632 L95.722,12.456 Z M108.211,22.824 L108.211,23.928 C107.851,24.048 107.491,24.096 107.083,24.096 C106.003,24.096 105.595,23.52 105.595,21.984 C104.563,23.616 103.219,24.336 101.227,24.336 C98.875,24.336 97.459,23.088 97.459,21.048 C97.459,19.56 98.203,18.48 99.643,17.928 C100.459,17.592 100.603,17.568 103.699,17.28 C105.091,17.136 105.523,16.776 105.523,15.792 C105.523,14.064 104.587,13.272 102.499,13.272 C100.531,13.272 99.547,14.112 99.355,16.008 L97.987,16.008 C98.107,13.512 99.787,12.12 102.643,12.12 C104.755,12.12 106.339,12.936 106.723,14.232 C106.843,14.688 106.891,15.12 106.891,16.128 L106.891,21.288 C106.891,22.728 106.987,22.92 107.683,22.92 C107.851,22.92 107.971,22.896 108.211,22.824 Z M105.523,19.584 L105.523,17.688 C105.067,18.096 104.731,18.192 102.331,18.504 C99.859,18.84 98.875,19.536 98.875,20.928 C98.875,22.296 99.955,23.184 101.563,23.184 C103.867,23.184 105.523,21.672 105.523,19.584 Z" id="beta" fill="#BDBEC3"></path>
        </g>
      </g>
    </g>
  </svg>
);
const SearchIcon = (
  <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="17px" height="17px" viewBox="0 0 17 17" version="1.1">
    <defs />
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-219.000000, -39.000000)" stroke="#FFFFFF" strokeWidth="0.1" fill="#131413">
        <g transform="translate(216.000000, 36.000000)">
          <path d="M14.5584227,15.1707741 C13.4450565,16.1542476 11.9791244,16.7480429 10.3832995,16.7480429 C6.8576399,16.7480429 4,13.890403 4,10.3647434 C4,6.83908379 6.8576399,4 10.3832995,4 C13.890403,4 16.7480429,6.83908379 16.7480429,10.3647434 C16.7480429,11.9605683 16.1542476,13.4265004 15.1893302,14.5584227 L19.9025805,19.2716729 C20.0324732,19.4015657 20.0324732,19.4943462 19.9025805,19.6242389 L19.6242389,19.9025805 C19.4943462,20.0324732 19.4201218,20.0324732 19.2902291,19.9025805 L14.5584227,15.1707741 Z M10.3832995,4.87213685 C7.34009858,4.87213685 4.89069295,7.34009858 4.89069295,10.3647434 C4.89069295,13.3893882 7.34009858,15.85735 10.3832995,15.85735 C13.4079443,15.85735 15.85735,13.3893882 15.85735,10.3647434 C15.85735,7.34009858 13.4079443,4.87213685 10.3832995,4.87213685 Z" id="search-icon" />
        </g>
      </g>
    </g>
  </svg>)

// const baseUrl = process.env.REACT_APP_EDCAT_URL;
const headerItems = ({ toggleSearch, SearchComponent }) => [
  {
    label: SearchIcon,
    onClick: toggleSearch,
    type: 'xl',
  },
  {
    label: SearchComponent,
    mobileOnly: true,
  },
  {
    path: '/items',
    label: 'editions',
  },
  {
    path: '/artists',
    label: 'artists',
  },
  {
    path: '/publishers',
    label: 'publishers',
  },
  {
    path: '/events',
    label: 'events',
  },
  {
    path: '/marketplace',
    label: 'marketplace',
  },
  {
    path: '/stories',
    label: 'stories',
    local: true,
  },
];


const StyledInput = styled.input`
  padding: 13px;
  background-color: #FFFFFF;
  width: 100%;
  font-size: 22px;
  line-height: normal;
  border: none;
  outline: none;
  margin-top: -2px;
  margin-left: -15px;
  caret-color: #2000FF;
  &::placeholder,
  &::-webkit-input-placeholder {
    color:#757575 !important;
  };
  :-ms-input-placeholder {
    color:#757575 !important;
  }
`;

const TransitionDiv = styled.div`
display: flex;
width:100%;
opacity:1;
transition: all 0.4s;
${props => !props.visible && `
  visibility: hidden;
  opacity:0;
`}
.nav-container{
  display:flex;
  >.nav{
    margin:auto;
  }
  +* .search-icon{
    display:none;
  }
}
`

const FullWidthDiv = styled.div`
  width: 100%;
`
const FormSearchContainer = styled.form`
  width: 100%;
  display: flex;
  svg {
    cursor:pointer;
    margin:auto;
    margin-left:30px;
    height:30px;
  }
`
const HeaderComponent = styled.header`
.mobile-nav .form-search {
  input {
    background:#f2f5f4;
    &::placeholder{
      font-size: 26px;
    }
  }
  svg:not(.search-icon){
    display:none;
  }
  svg{
    margin-left:-30px;
    pointer-events:none;
  }
  
${'' /* background: blue; */}
}
`

const denyClick = (e) => { e.preventDefault(); e.stopPropagation() }

const Header = (props) => {
  const {
    isMobileMenuOpen,
    toggleMobileMenu,
  } = props;
  const [editionsCount] = useStore('editionsCount');
  const { breakpoint } = useBreakpoint();
  const contextValue = useContext(HeaderContext) || {};
  const { alwaysShow } = contextValue;
  const [displaySearch, setDisplaySearch] = useState(false);
  const searchInputRef = useRef();
  const toggleSearch = useCallback(
    () => setDisplaySearch((prev) => { const newState = !prev; (newState && window.setTimeout(() => searchInputRef.current&&searchInputRef.current.focus&&searchInputRef.current.focus(), 100)); return newState }), [],
  )
  const { pathname } = useLocation();
  useEffect(() => { setDisplaySearch(false) }, [pathname])
  const [searchText, setSearchText] = useState('')
  const onSearchValueChanged = useCallback((e) => setSearchText(e.target.value), []);
  const onSubmitSearch = useCallback((e) => { e.preventDefault(); e.stopPropagation(); window.location.href = `${settings.ABSOLUTE_URL}/search/?q=${searchText}` }, [searchText])
  const toggleMobileView = useCallback(() => toggleMobileMenu(false), [toggleMobileMenu])
  const placeHolderText = `Search within ${displayNumber(editionsCount)} artists' books, editions, monographs and ephemera`
  const SearchComponent = (
    <FormSearchContainer className="form-search" onClick={denyClick} onSubmit={onSubmitSearch} >
      <StyledInput ref={searchInputRef} name="search" placeholder={(breakpoint === 'xl') ? placeHolderText : 'search'} value={searchText} onChange={onSearchValueChanged}></StyledInput>
      <CloseIcon onClick={toggleSearch} />
      {SearchIcon}
    </FormSearchContainer>
  )
  const headerItemsMemo = useMemo(() => headerItems({ toggleSearch, SearchComponent }), [SearchComponent, toggleSearch])
  const searchItemsMemo = useMemo(() => [headerItemsMemo[0]], [headerItemsMemo])
  return (
    <HeaderComponent className={classnames('Header', { mobileMenuIsOpen: isMobileMenuOpen, alwaysShow })}>
      <Headroom
        disableInlineStyles
        disable={alwaysShow}
        upTolerance={5}
        downTolerance={10}
      >
        <div className="header-container">
          <div className="logo-img-container">
            <Link className="logo-link" to={'/'} onClick={toggleMobileView}>
              {edcatLogo}
            </Link>
          </div>
          {<FullWidthDiv>
            <TransitionDiv visible={displaySearch} style={{ marginTop: -12 }}>
              <Nav type={breakpoint} items={searchItemsMemo} />
              {SearchComponent}
            </TransitionDiv>
            <TransitionDiv visible={!displaySearch} style={{ marginTop: -40 }}>
              {
                breakpoint === 'xl' ? (
                  <Nav type={breakpoint} items={headerItemsMemo} />
                ) : null
              }
              <div className="header-right">
                {
                  breakpoint === 'xl' ? (
                    <React.Fragment>
                      <Cart />
                      <div className="user-container">
                        <AccountUI />
                      </div>
                    </React.Fragment>
                  ) : (
                      <React.Fragment>
                        <Cart />
                        <div className="hamburger-container">
                          <Hamburger
                            isMobileMenuOpen={isMobileMenuOpen}
                            handleClickHamburger={toggleMobileMenu}
                          />
                        </div>
                      </React.Fragment>
                    )
                }
              </div>
            </TransitionDiv>
          </FullWidthDiv>}
        </div>
      </Headroom>
      {
        breakpoint !== 'xl' && <MobileNav type={breakpoint} toggle={toggleMobileMenu} items={headerItemsMemo} isOpen={isMobileMenuOpen} />
      }
    </HeaderComponent>
  )
}

export default Header;
